import React from "react";
import { Row, Col } from "antd/lib";
import {
	QuoteProduct,
	EditQuoteProductCatalogDrawerFormValues
} from "@/Contracts/ProposalBuilder/Block";

import "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/ConfigureDocumentProductDrawer.less";
import DocumentProductConfigureDrawerForm from "@/Components/DocumentsPage/Drawers/DocumentProductDrawers/DocumentProductConfigureDrawerForm/DocumentProductConfigureDrawerForm";

import { CloneProductToQuoteBlockDrawerProps } from "./interface";
import ZDrawer from "@molecules/ZDrawer";

const CloneProductToQuoteBlockDrawer: React.FC<
	CloneProductToQuoteBlockDrawerProps
> = props => {
	const defaultData =
		EditQuoteProductCatalogDrawerFormValues.fromQuoteProduct(
			props.productData
		);

	const handleSubmit = (data: QuoteProduct) => {
		props.onSubmit({
			...props.productData,
			...data,
			id: undefined
		});
	};

	return (
		<ZDrawer
			visible={props.visible}
			closable={true}
			destroyOnClose={true}
			onClose={props.onClose}
			className="document-product-drawer edit-document-product-drawer zomentum-drawer"
			title={
				<Row>
					<Col span={24}>
						<div className="drawer-title-container">
							<div className="drawer-title">
								Configure Product
							</div>
						</div>
					</Col>
				</Row>
			}
		>
			<DocumentProductConfigureDrawerForm
				okText="Clone Product"
				defaultData={defaultData}
				onClose={props.onClose}
				onSubmit={handleSubmit}
				currentActiveDocument={props.document}
			/>
		</ZDrawer>
	);
};

export default CloneProductToQuoteBlockDrawer;
